import restClient, {HEADER_DOMAIN_KEY} from "./BackendRestClient";
import publicTrackingRestClient from "./BackendRestClientWithoutHeaders";
import {FRONTEND_DOMAINS} from "../constants/DomainUrlConstants";
import {AxiosRequestConfig} from "axios";

export function shipmentSearch(searchQuery?: string, offset?: number, limit?: number) {
    const query = searchQuery ? searchQuery.trim() : "";
    return restClient.get(["shipment", "search"].join("/"), {
        params: {query: query, offset, limit}
    })
        .then(res => res)
}

export function publicTrackingSearch(searchQuery?: string) {
    const query = searchQuery ? searchQuery.trim() : "";
    return restClient.get(["shipment", "public-tracking"].join("/"), {
        params: {search: query}
    })
        .then(res => res)
}

export async function acrossAllModulesPublicTrackingSearch(searchQuery?: string) {
    const query = searchQuery ? searchQuery.trim() : "";

    const url = ["shipment", "public-tracking"].join("/");

    const config: AxiosRequestConfig = {
        params: {search: query},
    };
    const vcpResponse = await publicTrackingRestClient.get(url, {
        ...config,
        headers: {[HEADER_DOMAIN_KEY]: FRONTEND_DOMAINS.VCP}
    });

    const cpResponse = await publicTrackingRestClient.get(url, {
        ...config,
        headers: {[HEADER_DOMAIN_KEY]: FRONTEND_DOMAINS.CP}
    });

    const abcResponse = await publicTrackingRestClient.get(url, {
        ...config,
        headers: {[HEADER_DOMAIN_KEY]: FRONTEND_DOMAINS.ABC}
    });



    return [...vcpResponse.data.response, ...cpResponse.data.response, ...abcResponse.data.response];
}


export function getShipmentSummary(uuid: string) {
    return restClient.get(["shipment", "summary", uuid].join("/"))
        .then(res => res)
}

export function getShipmentDetails(uuid: string) {
    return restClient.get(["shipment", "detail", uuid].join("/"))
        .then(res => res)
}

export function getShipmentInfo(uuid: string) {
    return restClient.get(["shipment", "info", uuid].join("/"))
        .then(res => res)
}

export function getTransportParticipantsList(uuid: string) {
    return restClient.get(["shipment", "participants", uuid].join("/"))
        .then(res => res)
}

export function getShipmentDocumentList(uuid: string) {
    return restClient.get(["shipment", "document", uuid].join("/"))
        .then(res => res)
}

export function getShipmentPermissions(uuid: string) {
    return restClient.get(["shipment", "permissions", uuid].join("/"))
        .then(res => res)
}


export function downloadFile(document: any) {
    return restClient.post(["shipment", "download"].join("/"), document, {responseType: 'blob'})
        .then(res => res)
}
